<template>
  <el-dialog
    :visible="userDetailInfoVisible"
    center
    width="80%"
    title="汇总信息"
    @close="handleClose"
    :destroy-on-close="true"
  >
    <div class="main">
      <div class="search">
        <el-date-picker
          size="mini"
          v-model="dateValue"
          type="daterange"
          align="right"
          format="yyyy-MM-dd"
          clearable
          value-format="yyyy-MM-dd"
          unlink-panels
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
        >
        </el-date-picker>
        <el-select size="mini" v-model="filterType" placeholder="特殊账号">
          <el-option
            v-for="item in [
              { id: 1, value: '隐藏' },
              { id: 2, value: '显示' },
            ]"
            :key="item.id"
            :label="item.value"
            :value="item.id"
          />
        </el-select>
        <el-button size="mini" type="primary" @click="getInfoData"
          >搜 索</el-button
        >
      </div>
      <el-table :data="userDetailInfo" size="mini" max-height="400px">
        <el-table-column prop="" label="用户UID" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.userId }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="userTypeName" label="用户类型" align="center" min-width="120" />
        <el-table-column prop="" label="充值金额" align="center">
          <template slot-scope="scope">
            <span
              @click="goPage('/home/audit/deposite/records', userId)"
              class="myTd"
              >{{ scope.row.rechargeAmount }}</span
            >
          </template>
        </el-table-column>
        <el-table-column prop="" label="提现金额" align="center">
          <template slot-scope="scope">
            <span
              @click="goPage('/home/audit/withdraw/records', userId)"
              class="myTd"
              >{{ scope.row.txAmount }}</span
            >
          </template>
        </el-table-column>
        <el-table-column prop="" label="净充值" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.total }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="" label="盈利" align="center">
          <template slot-scope="scope">
            <span @click="goPage('/home/contractHistory')" class="myTd">{{
              scope.row.realizedProfit
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="" label="手续费" align="center">
          <template slot-scope="scope">
            <span @click="goPage('/home/contractHistory')" class="myTd">{{
              scope.row.fee
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="feeDay" label="手续费已返" align="center" />
        <el-table-column prop="" label="盈利汇总" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.profitTotal }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="spotBalance" label="现货余额" align="center" />
        <el-table-column prop="" label="合约总资产" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.tigerBalance }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="superBalance"
          label="超级合约资产"
          align="center"
        />
        <el-table-column prop="" label="余额汇总" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.balanceTotal }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop=""
          label="合约未结算盈亏"
          align="center"
          min-width="160"
        >
          <template slot-scope="scope">
            <span @click="goPage('/home/contractPosition')" class="myTd">{{
              scope.row.profit
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop=""
          label="合约已结算盈亏"
          align="center"
          min-width="160"
        >
          <template slot-scope="scope">
            <span @click="goPage('/home/contractPosition')" class="myTd">{{
              scope.row.tigerRealizedProfit
            }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="" label="赠币" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.sendCoin }}</span>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :size="pagination.size"
        :total="userDetailInfoTotal"
        :page="pagination.page"
        @pageChanged="getInfoData"
      >
      </pagination>
    </div>
    <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="infoVisible = false">取 消</el-button>
      </span> -->
  </el-dialog>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from "vuex";
import Pagination from "components/pagination";

export default {
  name: "UserDetailDialog",
  props: ["id", "type"],
  components: {
    Pagination,
  },
  data() {
    return {
      pagination: {
        page: 1,
        size: 10,
      },
      filterType: 1,
      dateValue: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  watch: {
    userDetailInfoVisible(newVal, oldVal) {
      // this.dateValue = []
      if (newVal) {
        this.getInfoData();
      }
    },
  },
  computed: {
    ...mapState("contractassets", [
      "userDetailInfo",
      "userDetailInfoVisible",
      "userDetailInfoTotal",
    ]),
  },
  methods: {
    ...mapActions("contractassets", ["getUserDetailInfo"]),
    ...mapMutations("contractassets", [
      "setUserDetailInfoVisible",
      "setUserDetailInfo",
    ]),
    getInfoData(pagination) {
      const paginations =
        pagination && pagination.size && pagination.page
          ? pagination
          : this.pagination;
      // 清空日期后 el-date-picker 可能为 null，不能直接 dateValue[0]
      const range = Array.isArray(this.dateValue) ? this.dateValue : [];
      let data = {
        startTime: range[0] ? range[0] : "",
        endTime: range[1] ? range[1] : "",
        userId: this.id,
        type: this.type,
        filterType: this.filterType,
        ...paginations,
      };
      console.log("data1111", data);
      this.getUserDetailInfo(data);
    },
    handleClose() {
      this.setUserDetailInfo({ list: [], totalCount: 0 }); //清空
      this.setUserDetailInfoVisible(false);
    },
  },
};
</script>

<style lang="less">
.pagination {
  padding-bottom: 0;
  padding-top: 20px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  .el-pagination__total {
    flex: 1;
    display: block;
    text-align: left;
  }
  * {
    font-weight: normal;
  }
}
.search {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}
</style>
